import React from 'react';

import './index.pc.scss';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcTypeItem from 'components/molecules/PcTypeItem';

import TextAreaBox from 'components/atoms/Input/TextAreaBox';
import PcErrorArea from 'components/molecules/PcErrorArea';


const PresentPC = ({ 
  onClickMainButton,
  valid,
  errorDispMap,
  typeList,
  otherWorkText,
  handleChangeOtherWorkText,
  lpMode,
}) => (
  <div className="OrderType">
    <PcBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      lpMode={lpMode}
    >
      <div className="pc-wrapper">

        {/* 身体介護・生活援助 */}
        {typeList.map((type)=>{
          const { title, text, typeState, checkState, stateOnChange, allCheckOnChange } = type;
          return(
            <PcTypeItem
              key={title}
              title={title}
              text={text}
              isAllCheck={checkState}
              allCheckOnChange={allCheckOnChange}
              typeState={typeState}
              stateOnChange={stateOnChange}
            />
          );
        })}
      
        {/* その他 */}
        <div className="pc-otherWork">
          <div className="otherWork-title">
            その他
          </div>
          <div className="otherWork-input">
            <TextAreaBox 
              name="otherWorkText"
              value={otherWorkText}
              onChange={handleChangeOtherWorkText}
              placeholder="上記に該当しない業務、および補足事項等"
              maxLength="100"
              inValid={!!errorDispMap.otherWorkText}
            />
            <PcErrorArea message={errorDispMap.otherWorkText} />
          </div>
          <div className="otherWork-horizon" />
        </div>
          
      </div>
    </PcBasicTemplate>
  </div>
);

export default PresentPC;
